import React, { Dispatch, ReactNode, SetStateAction, useState } from 'react';

type IntersitialContextProviderProps = {
  children: ReactNode;
};

type IntersitialContextValue = {
  preQuote: boolean;
  postQuote: boolean;
};

type IntersitialContextDispatch = Dispatch<
  SetStateAction<{ preQuote: boolean; postQuote: boolean }>
>;

const IntersitialContext = React.createContext<
  [IntersitialContextValue, IntersitialContextDispatch] | null
>(null);

export const IntersitialContextProvider = ({
  children,
}: IntersitialContextProviderProps) => {
  const value = useState({ preQuote: true, postQuote: true });

  return (
    <IntersitialContext.Provider value={value}>
      {children}
    </IntersitialContext.Provider>
  );
};

export const useIntersitialContext = () => {
  const context = React.useContext(IntersitialContext);

  if (!context) throw Error('context mus be wrapped inside Provider');

  return context;
};
